export default {
    home: '/worldcup/home',
    hometeam: '/worldcup/team',
    hometeamChange: '/worldcup/team/change',
    team: '/worldcup/team',
    player: '/worldcup/player',
    matchHome: '/worldcup/matchHome',
    liveHome: '/worldcup/liveHome',
    analysis: '/worldcup/matchHome/analysis',
};
